/**
 * Mavzu.
 *
 * Ombor yorug', ofis qorong'i — ikkalasi ham kerak. Tanlov
 * saqlanadi; tanlanmagan bo'lsa tizim sozlamasi kuzatiladi.
 */
export type Theme = "light" | "dark" | "system";

const KEY = "uyda.theme";
const DARK_QUERY = "(prefers-color-scheme: dark)";

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "light" || stored === "dark" || stored === "system") return stored;
  } catch {
    /* e'tiborsiz */
  }
  return "system";
}

export function resolvedTheme(theme: Theme): "light" | "dark" {
  if (theme !== "system") return theme;
  return window.matchMedia(DARK_QUERY).matches ? "dark" : "light";
}

/**
 * Mavzuni DOMga qo'llaydi.
 *
 * `data-theme` har doim HAL QILINGAN qiymatni saqlaydi — "system"
 * ham `light` yoki `dark` ga aylantiriladi. Ilgari "system" da
 * atribut umuman olib tashlanardi va CSSda `prefers-color-scheme`
 * qoidasi yo'qligi uchun interfeys qorong'i tizimda ham YORUG'
 * bo'lib qolardi, mavzu tugmasi esa "yorug'ga o'tish" belgisini
 * ko'rsatib turardi.
 *
 * Tanlovning O'ZI (jumladan "system") alohida saqlanadi: aks
 * holda keyingi ochilishda u "dark" bo'lib qotib qolardi va
 * tizim sozlamasi o'zgarganda kuzatilmasdi.
 */
export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", resolvedTheme(theme));
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* e'tiborsiz */
  }
}

/**
 * Tizim mavzusi o'zgarishini kuzatadi.
 *
 * Faqat "system" tanlovida ma'noga ega: aniq tanlov qilingan
 * bo'lsa, tizim sozlamasi uni bekor qilmasligi kerak.
 */
export function watchSystemTheme(theme: Theme, onChange: () => void): () => void {
  if (theme !== "system") return () => {};

  const media = window.matchMedia(DARK_QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}
